import React from 'react';
const ContrListCol = (props) => {
  return(
    <td style={props.colObj.style}>
      <span>{props.colObj.value}</span>
    </td>
  )
}
export default ContrListCol;
